export default __webpack_public_path__ + "static/media/img-7.6148ca67.jpg";